import Header from "./components/header";
import MainBlock from "./components/MainBlock";
import TableBlock from "./components/table-block/table-block";
import InfoBlock from "./components/info-block";
import PriceBlock from "./components/price-block/price-block";
import InfoBlock2 from "./components/InfoBlock2";
import InfoBlock3 from "./components/info-block-3";
import InfoBlock4 from "./components/info-block-4";
import ContactBlock from "./components/ContactBlock";
import Footer from "./components/Footer";
import AOS from 'aos';
import 'aos/dist/aos.css';
import {useEffect} from "react";
function App() {

    useEffect(() => {
        AOS.init({ duration: 1000 }); // Настройка длительности анимации
    }, []);


    return (
        <div className="App">
            <Header/>
            <MainBlock/>
            <TableBlock />
            <InfoBlock />
            <PriceBlock/>
            <InfoBlock2 />
            <InfoBlock3 />
            <InfoBlock4 />
            <ContactBlock />
            <Footer />
        </div>
    );
}

export default App;
